import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { LoadingService } from './loading.service';
import '@angular/localize/init';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'] // Corrected styleUrl to styleUrls
})
export class AppComponent implements AfterViewInit, OnDestroy {
  environment: string = '';
  loading: boolean = false;
  private loadingSubscription!: Subscription;

  constructor(private loadingService: LoadingService,  private translate: TranslateService) {
    // Configurar o idioma padrão
    const defaultLang = 'en'; // ou 'pt'
    const savedLang = localStorage.getItem('language') || defaultLang;

    this.translate.setDefaultLang(defaultLang);
    this.translate.use(savedLang);
  }

  ngOnInit(): void {
    this.environment = localStorage.getItem('environment') ?? 'Production';
    this.requestNotificationPermission();
  }

  requestNotificationPermission() {
    if ('Notification' in window) {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          console.log("✅ Notificações permitidas!");
        } else {
          console.warn("⚠️ Notificações bloqueadas pelo usuário.");
        }
      });
    } else {
      console.error("❌ O navegador não suporta notificações.");
    }
  }
  
  changeLanguage(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('language', lang); // Salvar a preferência no localStorage
  }

  ngAfterViewInit(): void {
    this.loadingSubscription = this.loadingService.loading$.subscribe((loading: boolean) => {
      Promise.resolve().then(() => {
        this.loading = loading; // Update happens in the next microtask
      });
    });
  }

  ngOnDestroy(): void {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }

  
}